var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('branch-office-picker',{attrs:{"value":_vm.currentBranchOffice,"only-scoped":""},on:{"change":_vm.onOfficeSelect,"loading":function($event){_vm.loading=true},"loaded":_vm.onLoaded}})}
var staticRenderFns = []

export { render, staticRenderFns }